import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext();
const LANGUAGE_STORAGE_KEY = "language";

const readStoredLanguage = () => {
    try {
        const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
        if (stored === "ru" || stored === "en") return stored;
    } catch (e) {}
    return "en";
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        const initial = readStoredLanguage();
        try {
            localStorage.setItem(LANGUAGE_STORAGE_KEY, initial);
        } catch (e) {}
        return initial;
    });

    const toggleLanguage = () => {
        setLanguage(prev => {
            const next = prev === "ru" ? "en" : "ru";
            try {
                localStorage.setItem(LANGUAGE_STORAGE_KEY, next);
            } catch (e) {}
            return next;
        });
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
